"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PANAMERA = exports.BIFROST_JWT_TOKEN = void 0;
var BIFROST_JWT_TOKEN = exports.BIFROST_JWT_TOKEN = '_bifro_jwt';
var PANAMERA = exports.PANAMERA = 'panamera';